export const useFooterLinks = () => ([
  {},
  {
    links: [
      {
        label: "Măsuri anti-Covid",
        to: "/anti-covid",
      },
      {
        label: "Politica de confidențialitate",
        to: "/politica-de-confidentialitate",
      },
      {
        label: "Termeni și condiții",
        to: "/termeni-si-conditii",
      },
    ]
  },
  {
    links: [
      {
        label: "ITF - Ediția 2019",
        to: "https://2019.imaginetimisoara.ro",
        isExternal: true,
      },
      {
        label: "ITF - Ediția 2020",
        to: "https://2020.imaginetimisoara.ro",
        isExternal: true,
      },
    ]
  }
]);